function isElectron() {
    return navigator.userAgent.toLowerCase().indexOf("electron") > -1;
}

function getElectronVersion() {
    const userAgent = navigator.userAgent.toLowerCase();
    const match = userAgent.match(/electron\/(\d+\.\d+\.\d+)/);
    return match ? match[1] : null;
}

function shouldPatch(version) {
    if (typeof version !== "string") return false;
    const [major, minor, patch] = version.split(".").map(Number);
    return major < 32;
}

if (isElectron()) {
    const version = getElectronVersion();
    //elctron中32版本之前的chromium内核存在getBoundingClientRect方法的bug,该bug的现象是当使用了zoom属性进行缩放时返回的值不对
    //在教师端“核桃辅助”里使用ide时用了zoom属性来缩小ide,使用时导致从flyout拖出代码块时，删除区域不对，导致一拖出来就删除，所以这里做一个patch
    // 教师端目前没有计划更新electron版本，所以这里做一个patch
    //https://chromium-review.googlesource.com/c/chromium/src/+/5085708
    if (shouldPatch(version)) {
        (function () {
            function isZoomAccurate() {
                // 创建临时div
                const tempDiv = document.createElement("div");
                tempDiv.style.visibility = "hidden";

                // 设置宽高为 4 像素
                tempDiv.style.width = "4px";
                tempDiv.style.height = "4px";

                // 隐藏 div 以避免影响页面布局
                tempDiv.style.position = "absolute";
                tempDiv.style.left = "-9999px";
                tempDiv.style.top = "-9999px";

                // 将 div 添加到 body
                document.body.appendChild(tempDiv);

                // 获取未缩放时的宽度
                const originalWidth = tempDiv.getBoundingClientRect().width;
                console.log("originalWidth before zoom", originalWidth);

                // 设置 zoom 为 0.5
                tempDiv.style.zoom = "0.5";

                // 获取缩放后的宽度
                const zoomedWidth = tempDiv.getBoundingClientRect().width;
                console.log("zoomedWidth after zoom", zoomedWidth);

                // 清理临时 div
                document.body.removeChild(tempDiv);

                // 判断 zoom 功能是否正常
                return originalWidth !== zoomedWidth;
            }

            function overrideBoundingClientRectForZoom() {
                const originalGetBoundingClientRect =
                    Element.prototype.getBoundingClientRect;
                // 重写 getBoundingClientRect 方法
                Element.prototype.getBoundingClientRect = function () {
                    const zoomFactor =
                        parseFloat(getComputedStyle(document.body).zoom) ||
                        parseFloat(document.body.style.zoom);
                    console.log("zoomFactor", zoomFactor);
                    if (!isNaN(zoomFactor) && zoomFactor !== 1) {
                        const rect = originalGetBoundingClientRect.call(this);
                        return {
                            ...rect,
                            width: rect.width * zoomFactor,
                            height: rect.height * zoomFactor,
                            top: rect.top * zoomFactor,
                            right: rect.right * zoomFactor,
                            bottom: rect.bottom * zoomFactor,
                            left: rect.left * zoomFactor,
                        };
                    }
                    return originalGetBoundingClientRect.call(this);
                };
            }

            if (isZoomAccurate()) {
                console.log(
                    "BoundingRect width is correct in zoom, no need to override it"
                );
            } else {
                overrideBoundingClientRectForZoom();
                console.log(
                    "BoundingRect width is incorrect in zoom, override it"
                );
            }
        })();
    }
}
